module.exports = __webpack_public_path__ + "img/profile_box_special_skill.adf3d9d8.svg";